import { handleTextValidation } from '@/utils'
import { SubmitHandler, useForm } from 'react-hook-form'
interface UserFormProps {
  handleFormSubmit: (data: FormData) => void
  siteName?: string
}

export interface FormData {
  Name: string
  Email: string
}

const UserForm = ({ handleFormSubmit, siteName }: UserFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      Name: '',
      Email: '',
    },
  })

  const onSubmit: SubmitHandler<FormData> = data => {
    handleFormSubmit(data)
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className='flex-1 pt-[30px] pb-[30px] px-[16px] space-y-4 overflow-auto'
    >
      <div>
        <label
          htmlFor='name'
          className='block text-sm font-medium text-gray-700'
        >
          Name<span className='error-msg'>*</span>
        </label>
        <input
          id='name'
          {...register('Name', {
            required: 'Name is required',
            minLength: {
              value: 2,
              message: 'Name must be at least 2 characters',
            },
            maxLength: {
              value: 20,
              message: 'Name must be less than 20 characters',
            },
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: 'Name can only contain letters and spaces',
            },
            validate: value =>
              !/\s{2,}/.test(value) || 'Name cannot contain consecutive spaces',
          })}
          maxLength={20}
          onKeyDown={handleTextValidation}
          className={`w-full border rounded-lg px-3 py-2 mt-1 ${
            errors.Name ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {errors.Name && (
          <p className='text-red-500 text-sm mt-1'>{errors.Name.message}</p>
        )}
      </div>

      <div>
        <label
          htmlFor='email'
          className='block text-sm font-medium text-gray-700'
        >
          Email<span className='error-msg'>*</span>
        </label>
        <input
          id='email'
          type='email'
          {...register('Email', {
            required: 'Email is required',
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'Invalid email address',
            },
          })}
          className={`w-full border rounded-lg px-3 py-2 mt-1 ${
            errors.Email ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {errors.Email && (
          <p className='text-red-500 text-sm mt-1'>{errors.Email.message}</p>
        )}
      </div>

      <button
        type='submit'
        className={`w-full bg-black px-[15px] py-[12px] ${
          !siteName ? 'rounded-[12px]' : ''
        } text-[18px] text-white mt-[30px] hover:bg-[#383838] cursor-pointer`}
      >
        Start Chat
      </button>

      <p className='text-gray-700 text-[10px]'>
        <strong className='text-black'>Note: </strong>
        When you use our ProInstaller Ai tool, we require your email address
        solely for access and communication purposes. Your information is used
        only by ProInstaller Magazine and will never be sold, shared, or
        provided to any third party.
      </p>
    </form>
  )
}

export default UserForm
